
// document.addEventListener('DOMContentLoaded', function () {
//   const elDivs = document.querySelectorAll("ul.product-grid li.grid__item .card .card__media .media img");
  
//   const toggleClassDivs = (evt) => {
//     const isEnter = evt.type === "mouseenter";
//     elDivs.forEach(el => el.classList[isEnter ? "add" : "remove"]("first_anim"));
//     evt.currentTarget.classList.remove("first_anim");
//     evt.currentTarget.classList.add("second_anim");
//   };
  
//   elDivs.forEach(el => {
//     el.addEventListener("mouseenter", toggleClassDivs);
//     el.addEventListener("mouseleave", toggleClassDivs);
//   });
// })

// document.addEventListener("DOMContentLoaded", (event) => {
//   const videoCardLinks = document.querySelectorAll("ul.product-grid li.grid__item .card");

//   videoCardLinks.forEach((el) => {
//     el.addEventListener("mouseover", (e) => {
//       e.target.closest(".grid__item").classList.add("first_anim");
//     });
//     el.addEventListener("mouseout", (e) => {
//       e.target.closest(".grid__item").classList.remove("first_anim");
//       e.target.closest(".grid__item").classList.add("second_anim");
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('customPopup');
    const closeBtn = popup.querySelector('.close-popup');

    // Show popup 1 second after page load
    setTimeout(() => {
      popup.classList.add('show');
      document.body.style.overflow = 'hidden'; // prevent background scroll
    }, 1000);

    // Close popup on X click
    closeBtn.addEventListener('click', () => {
      popup.classList.remove('show');
      setTimeout(() => popup.style.display = 'none', 300);
      document.body.style.overflow = '';
    });

    // Close when clicking outside popup
    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        popup.classList.remove('show');
        setTimeout(() => popup.style.display = 'none', 300);
        document.body.style.overflow = '';
      }
    });
});